import { usePermissions } from 'react-admin';

/** @typedef {('admin' | 'supervisor' | 'case_manager' | 'quality_reviewer' | 'backend_reviewer' | 'team_leader'| 'contract_user' | 'view_admin' | 'admin_assistant' | 'covering_user' | 'is_final_examiner')} Role */

export function useGetUserRoles() {
  const { permissions } = usePermissions();

  /** @type {Role[]} */
  const userPermissions = permissions ? permissions.split(',') : [];

  const has = (/** @type {Role} */ role) => userPermissions.includes(role);
  const hasOneOf = (/** @type {Role[]} */ roles) =>
    userPermissions.some(role => roles?.includes(role));

  return {
    has,
    hasOneOf,
    allRoles: userPermissions,
    is_admin: has('admin'),
    is_supervisor: has('supervisor'),
    is_case_manager: has('case_manager'),
    is_quality_reviewer: has('quality_reviewer'),
    is_contract_user: has('contract_user'),
    is_view_admin: has('view_admin'),
    is_admin_assistant: has('admin_assistant'),
    is_covering_user: has('covering_user'),
    is_final_examiner: has('final_examiner'),
    is_team_lead: has('team_lead'),
    profileLoaded: !!permissions,
  };
}
